var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"app":"","flat":"","color":_vm.$vuetify.theme.dark ? '#121212' : 'white'}},[_c('v-toolbar-title',[_vm._v("HakHak Status")]),_c('v-spacer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }